import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import {
  getAccountImporterPayments,
  getAccountImporterPayment,
  createAccountImporterPayment,
  updateAccountImporterPayment,
  deleteAccountImporterPayment,
} from 'api/accountImporterPaymentApi'

export const useAccountImporterPayments = (params = {}, enabled = true) => {
  return useQuery({
    queryKey: ['account-importer-payments', params],
    queryFn: () => getAccountImporterPayments(params),
    enabled,
  })
}

export const useAccountImporterPayment = (id, enabled = true) => {
  return useQuery({
    queryKey: ['account-importer-payments', id],
    queryFn: () => getAccountImporterPayment(id),
    enabled: enabled && !!id,
  })
}

export const useCreateAccountImporterPayment = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: createAccountImporterPayment,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['account-importer-payments'] })
    },
  })
}

export const useEditAccountImporterPayment = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ id, ...data }) => updateAccountImporterPayment(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['account-importer-payments'] })
    },
  })
}

export const useDeleteAccountImporterPayment = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: deleteAccountImporterPayment,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['account-importer-payments'] })
    },
  })
}
